

import BaseTemplate from '../../src/layouts/BaseTemplate'
import RegisterBody from '../../src/view/_public/RegisterBody';

export default function Register() {

  return (<></>)

  // return (
  //   <BaseTemplate title="Register" body={<RegisterBody />} />
  // )
}
